import { jsx as _jsx } from "react/jsx-runtime";
var ArrowDown = function ArrowDown(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 4.38618L2.50221 3L6 6.22763L9.49779 3L11 4.38618L6 9L1 4.38618Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default ArrowDown;